import type { EChartsOption } from "echarts";
import EChartBase from "./EChartBase";
import { chartPalette } from "./ChartTheme";

export type RadarDatum = {
  label: string;
  value: number;
  target?: number;
};

type Props = {
  data: RadarDatum[];
  height?: number | string;
};

export default function RadarChart({ data, height = 330 }: Props) {
  const option: EChartsOption = {
    color: [chartPalette.blue, chartPalette.amber],
    tooltip: {},
    legend: data.some((x) => x.target !== undefined) ? { top: 0 } : undefined,
    radar: {
      radius: "65%",
      indicator: data.map((x) => ({
        name: x.label,
        max: Math.max(100, x.value || 0, x.target || 0),
      })),
    },
    series: [
      {
        type: "radar",
        areaStyle: {},
        data: [
          { name: "Actual", value: data.map((x) => x.value || 0) },
          ...(data.some((x) => x.target !== undefined)
            ? [{ name: "Target", value: data.map((x) => x.target || 0) }]
            : []),
        ],
      },
    ],
  };

  return <EChartBase option={option} height={height} empty={!data?.length} />;
}